<select [formControl]="control" [ngClass]="{'invalid': !control.valid && (!control.pristine || submitted)}"
  [(ngModel)]="selectedValue">
  <option style="color: #757575;" value="null" disabled selected>{{'USER_SIGN_UP_COUNTRY_LABEL' | translate}}</option>
  <option *ngFor="let country of countries" [ngValue]="country.CountryCode">{{country.CountryName}}</option>
</select>

<div [ngClass]="errorClass ? errorClass : ''" class="error-msg" *ngIf="control.errors && submitted">
  {{'FORM_ERROR_MESSAGE_REQUIRED' | translate}}
</div>
